/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TableContext from './tableContext';

import styles from '../styles/uikitTablesTableCell.module.scss';

const TableCell = forwardRef(({
  align = 'left',
  className = '',
  children = null,
  scope: scopeProp,
  testId = '',
  ...other
}, ref) => {
  const elementContext = useContext(TableContext);

  const isTableHead = elementContext === 'head';

  const Element = isTableHead ? 'th' : 'td';

  let scope = scopeProp;
  if (!scope && isTableHead) {
    scope = 'col';
  }

  return (
    <Element
      className={classnames(styles.element, {
        [styles.isAlignedRight]: align === 'right',
      }, className)}
      data-testid={testId}
      ref={ref}
      scope={scope}
      {...other}
    >
      {children}
    </Element>
  );
});

TableCell.displayName = 'TableCell';

TableCell.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  scope: PropTypes.string,
  testId: PropTypes.string,
};

export default TableCell;
